"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasEndingTrackingDataSelector = exports.isTrackingLoadingSelector = exports.isChangeLogLoadingSelector = exports.changeLogItemsSelector = void 0;
const changeLogItemsSelector = (state) => {
    return state.tracking.trackData;
};
exports.changeLogItemsSelector = changeLogItemsSelector;
const isChangeLogLoadingSelector = (state) => {
    return state.tracking.hasTrackingError;
};
exports.isChangeLogLoadingSelector = isChangeLogLoadingSelector;
const isTrackingLoadingSelector = (state) => {
    return state.tracking.isTrackingLoading;
};
exports.isTrackingLoadingSelector = isTrackingLoadingSelector;
const hasEndingTrackingDataSelector = (state) => {
    return state.tracking.hasEndingTrackingData;
};
exports.hasEndingTrackingDataSelector = hasEndingTrackingDataSelector;
